import { AfterViewInit, Component, computed, EventEmitter, Input, Output, signal, ViewChild, inject } from '@angular/core';
import { IPopupModel } from '@mwe/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormComponent } from '../form/form.component';
import { NgClass } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { BasicCardComponent } from '../cards/basic-card/basic-card.component';
import { ButtonComponent } from '../buttons/button/button.component';

@Component({
  selector: 'mwe-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  imports: [NgClass, TranslateDirective, FormComponent, TranslatePipe, BasicCardComponent, ButtonComponent],
})
export class ModalDialogComponent implements AfterViewInit {
  private activeModal = inject(NgbActiveModal);

  @ViewChild(FormComponent, { static: false }) formComponent: FormComponent;
  @Input() model: IPopupModel;
  @Output() onAdditionalButtonClick = new EventEmitter<string>();

  modelSignal = signal<IPopupModel>(null);

  modalIconClass = computed(() => {
    switch (this.modelSignal()?.iconColorClass) {
      case 'green':
        return 'gradient-success';
      case 'yellow':
        return 'gradient-warning';
      case 'red':
        return 'gradient-danger';
      case 'blue':
        return 'gradient-info';
      default:
        return 'gradient-info';
    }
  });

  ngAfterViewInit() {
    this.modelSignal.set(this.model);
  }

  clickAdditionalButton(buttonId: string): void {
    this.onAdditionalButtonClick.emit(buttonId);
  }

  getAdditionalButtonId(buttonId: string, idx: string): string {
    return buttonId ? buttonId : 'mwe-additional-button-' + idx;
  }

  cancel(): void {
    this.activeModal.close('CANCEL');
  }

  submit(): void {
    if (this.modelSignal().formModel) {
      this.activeModal.close(this.formComponent.form.value);
    } else {
      this.activeModal.close(this.modelSignal().subscriptionId ? this.modelSignal().subscriptionId : 'OK');
    }
  }
}
